export default __webpack_public_path__ + "static/media/logout_blue.d79fddc5.svg";